import { render, staticRenderFns } from "./Tree.vue?vue&type=template&id=92b3c9ec&scoped=true"
var script = {}
import style0 from "./Tree.vue?vue&type=style&index=0&id=92b3c9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b3c9ec",
  null
  
)

export default component.exports